import APP from 'src/main.js'
import ControlledByMixin from './ControlledByMixin'
// import AppRecord from './AppRecord'

class Account extends ControlledByMixin {
  get virtual(){
    return this.bank_id ? false : true
  }
  get ceased(){
    if(this.cease_date){
      return this.cease_date <= (new Date).to_s()
    } else {
      return false
    }
  }
  get real(){
    return (this.auto_manage === false) && this.bank
  }
  get unchecked_event_count(){
    return this.event_count - this.controlled_event_count
  }
  get require_control(){
    if(this.auto_manage || this.virtual || this.ceased){return false}
    if(this.event_count === 0){return false}
    if(this.unchecked_event_count > 0){return true}
    return this.controlled_days_ago > this.control_frequency
  }
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)
  }
  get account_rates(){
    return this.constructor.employeeStore.account_rates.filter(rate => rate.account_id === this.id)
  }
  get events(){
    return this.constructor.employeeStore.events.filter(ev => ev.account_id === this.id)
  }
  get deposit(){
    return this.constructor.employeeStore.deposits.find(dep => dep.id === this.deposit_id)
  }
  get bank_contact(){
    return this.constructor.employeeStore.peopleById.get(this.bank_contact_id)
  }
  get transaction_rules(){
    return this.constructor.employeeStore.transaction_rules.filter(rule => rule.bank_id === this.bank_id)
  }

  get bank(){
    return this.constructor.employeeStore.banks?.find(bank => bank.id === this.bank_id)
  }

  get is_ss_bank(){
    return this.bank_id === 28 && this.bank_id !== null
  }

}

export default Account
